import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router }                                         from '@angular/router';
import { Edition }                                        from '../models/global/edition';
import { User }                                           from '../models/program/user';
import { UserService }                                    from '../dashboard/program-list/user.service';
import { ApiService }                                     from '../root-services/api.service';
import { EditionListService }                             from '../editions/edition.service';
import { Response } from '@angular/http';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.less']
})

export class SearchResultsComponent implements OnInit {
  @Input() searchResults: Object[];
  @Input() searchString: string;
  @Input() email: string;
  @Output() emitEmail: EventEmitter<string> = new EventEmitter<string>();
  @Output() reset: EventEmitter<boolean> = new EventEmitter<boolean>();
  public analytics = false;
  public result: any = null;
  public selectedUser: User = null;
  public individualID: number;
  public groupObj: null;

  constructor(
    private userService: UserService,
    private router: Router,
    private api: ApiService,
    private editionApi: EditionListService
  ) { }

  ngOnInit(): void { }

  public emitString(): void {
    this.emitEmail.emit(this.email);
  }

  private openUserSettings(result) {
      this.userService.getUser(result.id)
                      .subscribe(u => this.selectedUser = u);
  }

  private openUserAnalytics(result, group): void {
    this.analytics = true;
    this.individualID = result.id;
    if(group) {
      this.groupObj = group;
    }
    else if(result.groups.length === 1) {
      this.groupObj = result.groups[0];
    }
    else {
      this.groupObj = null;
    }
  }

  private closeUserAnalytics(): void {
    this.analytics = false;
    this.individualID = null;
  }

  private gotoGroup(result) {
    this.router.navigate(['dashboard', 'programs', result.program_id, 'teams', result.id, 'users']);
    this.reset.emit();
  }

  private gotoWave(result) {
    this.router.navigate(['dashboard', 'programs', result.program_id, 'teams']);
    this.reset.emit();
  }

  private gotoProgram(result) {
    this.router.navigate(['dashboard', 'programs', result.id]);
    this.reset.emit();
  }

  private gotoGroupAnalytics(result) {
    this.router.navigate(['analytics', 'snapshot', {programId: result.program_id, group: result.id}]);
    this.reset.emit();
  }

  private gotoWaveAnalytics(result) {
    this.router.navigate(['analytics', 'snapshot', {programId: result.program_id, wave: result.id}]);
    this.reset.emit();
  }

  private gotoProgramAnalytics(result) {
    this.router.navigate(['analytics', 'snapshot', {program: result.id}]);
    this.reset.emit();
  }

  private gotoSubscription(result) {
    this.router.navigate(['subscriptions', result.id, 'users']);
    this.reset.emit();
  }

  private chooseEdition(edition: Edition) {
    this.editionApi.setCurrentEdition(edition);
    this.router.navigate(['dashboard']);
    this.reset.emit();
    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/search-results/search-results.component.ts